/**
 * Crea el boton de repetir apuesta
 * @param {*} scene
 */
export function crearBotonRepetir(scene) {
  // Crear el botón y asignarlo a la propiedad scene.botonRepetir
  scene.botonRepetir = scene.add
    .image(698, 418, "botonRepetir")
    .setInteractive();

  scene.botonRepetir.on("pointerover", () => {
    if (!scene.noVaMas){
      scene.botonRepetir.setTexture("botonRepetirHover");
    }
  });

  scene.botonRepetir.on("pointerout", () => {
    if (!scene.noVaMas){
      scene.botonRepetir.setTexture("botonRepetir");
    }
  });

  scene.botonRepetir.on("pointerdown", () => {
    if (!scene.noVaMas){
      scene.botonRepetir.setTexture("botonRepetirPressed");
    }
  });

  scene.botonRepetir.on("pointerup", () => {
    if (!scene.noVaMas){
      if (scene.botonRepetir.input?.isOver) {
        scene.botonRepetir.setTexture("botonRepetir");
      } else {
        scene.botonRepetir.setTexture("botonRepetirHover");
        scene.repetirUltimaApuesta();
      }
    }
  });
}